<div class="alert alert-info" ng-show="vm.exams.length == 0">Keine Daten gefunden</div>

<!--table-->
<!-- Must use ng-if to display, ng-show will not render automatically, only after resize -->
<div class="gridStyle" ui-grid="vm.gridOptions" ng-if="vm.exams.length > 0"></div>

<!--template for action buttons-->
<script type="text/ng-template" id="examactiontemplate">

    <span style="text-align: right">
      <!-- Biopsie eintragen -->
      <a ng-click="grid.appScope.vm.editExam(row.entity, $index)" class="btn btn-success btn-xs"
         ng-show="row.entity.template.biopsy"
         uib-tooltip="Biopsiebericht eintragen"><i class="fa fa-flask"></i></a>
        <!-- Existierendes PDF anzeigen -->
        <a href="/routes/pdfreader/{{row.entity.docid}}" target="_blank" class="btn btn-primary btn-xs" uib-tooltip="Anzeigen">
            <i ng-show="!vm.spinners[$index]" class="fa fa-eye"></i>
            <i ng-show="vm.spinners[$index]" class="fa fa-spinner fa-spin"></i>
        </a>
        <!-- existierendes PDF laden -->
        <a href="/routes/pdfdownload/{{row.entity.docid}}" class="btn btn-primary btn-xs" uib-tooltip="Herunterladen">
            <i class="fa fa-download"></i>
        </a>
        <!-- Untersuchung nachträglich editieren, mit Rückfrage -->
        <a ng-really-click="grid.appScope.vm.editExam(row.entity, $index)"
           ng-really-message="Wollen Sie wirklich diese Untersuchung nachträglich editieren und einen neuen PDF Befund erstellen?"
           class="btn btn-warning btn-xs"
           uib-tooltip="Editieren &amp; neues PDF erzeugen">
            <i class="fa fa-edit"></i>
        </a>
      </span>
</script>




